module.exports = __webpack_public_path__ + "img/rollcall_2.4999b0bc.png";